import { call, put, takeLatest, fork, all, } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as RatingService from './../services/ratingService';
import * as RatingActions from './../actions/ratingAction';
import * as Func from "../helpers/functions";
import { parseRatingListRequestParams } from '../utils/commonUtils';
import { PATHS } from '../constants/Define';

function* getListRating() {
    yield takeLatest(Types.RATING_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseRatingListRequestParams(action.filters || {});
        const result = yield call(RatingService.getRatings, params);
        yield put(RatingActions.setListRatings(result));
    }, errorHandleRating(Types.RATING_FAIL)))
}

function* approveRating() {
    yield takeLatest(Types.RATING_APPROVE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RatingService.approveRating, action.rating);
        yield put(RatingActions.approveRatingSuccess(action.rating));
    }, errorHandleRating(Types.RATING_FAIL)))
}

function* deleteRating() {
    yield takeLatest(Types.RATING_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RatingService.deleteRating, action.rating);
        yield put(RatingActions.deleteRatingSuccess(action.rating));
        yield put({ type: Types.RATING_LIST_ACTION, params: action.refreshParams })
    }, errorHandleRating(Types.RATING_FAIL)))
}

function* approveRatingReply() {
    yield takeLatest(Types.RATING_REPLY_APPROVE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RatingService.approveRatingReply, action.reply);
        yield put(RatingActions.approveRatingReplySuccess(action.reply));
    }, errorHandleRating(Types.RATING_FAIL)))
}

function* deleteRatingReply() {
    yield takeLatest(Types.RATING_REPLY_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RatingService.deleteRatingReply, action.reply);
        yield put(RatingActions.deleteRatingReplySuccess(action.reply));
        yield put({ type: Types.RATING_LIST_ACTION, params: action.refreshParams })
    }, errorHandleRating(Types.RATING_FAIL)))
}

function errorHandleRating(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'rating');
}

export function* ratingSaga() {
    yield all([
        fork(getListRating),
        fork(approveRating),
        fork(deleteRating),
        fork(approveRatingReply),
        fork(deleteRatingReply),
    ])
}
